import styled from 'styled-components';

import { IAnimate } from './types';

export const AnimateBlock = styled.div<IAnimate>`
  animation-name: ${({ animate }) => animate};
  animation-duration: ${({ duration }) => duration}s;
  animation-timing-function: ${({ timingFunction }) => timingFunction};
`;

export const OverflowHidden = styled.div`
  overflow: hidden;
`;
